/**
 * Observability system configuration.
 * 
 * This module centralizes all configuration for the observability system,
 * making it easy to adjust behavior across environments.
 */

import { isDevelopment, isProduction, isStaging, isStageTwo } from 'utils/environment';

/**
 * Available observability providers.
 */
export type ObservabilityProviderType = 'newrelic' | 'console';

/**
 * Observability system configuration.
 */
export interface ObservabilityConfig {
  /** Which provider to use for event tracking */
  provider: ObservabilityProviderType;
  
  /** Enable verbose logging in development mode */
  enableDevMode: boolean;
}

/**
 * Get the active observability configuration based on the current environment.
 * 
 * - Production/Staging: Uses NewRelic provider with dev mode disabled
 * - Development: Uses console provider with dev mode enabled
 * 
 * @returns The active observability configuration
 */
export function getObservabilityConfig(): ObservabilityConfig {
  const isProductionEnvironment = isProduction || isStaging || isStageTwo;
  
  return {
    provider: isProductionEnvironment ? 'newrelic' : 'console',
    enableDevMode: isDevelopment,
  };
}

